import { createRouter, createWebHistory } from '@ionic/vue-router';
import { RouteRecordRaw } from 'vue-router';
import GISPage from '@/views/institution/GISPage.vue'
import GeneralLayout from '@/layouts/GeneralLayout.vue'
import Program from '@/views/program/Program.vue'
import CityChart from '@/views/chartPages/cityChart.vue'
import ProgramContent from '@/views/chartPages/ProgramContent.vue'
import DistrictChart from '@/views/chartPages/districtChart.vue'
import ChartDetail from '@/views/chartDetailPages/chartDetail.vue'
import EntryPages from '@/views/entryPages/entryPages.vue'
import ParticipatingInstitutions from '@/views/chartDetailPages/participatingInstitutions.vue'
import Login from '@/views/Login.vue'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/login',
    name: 'login' ,
    component: Login
  },
  // {
  //   path: '',
  //   name: 'home' ,
  //   redirect: '/user/institution/gis'
  // },
  {
    path: '/user',
    component: GeneralLayout,
    children: [
      {
        path: '/user/institution/gis',//访问路径
        name: 'GISPage',
        component: GISPage
      },
      {
        path: '/user/program',
        name: 'Program',
        component: Program
      },
      {
        path: '/user/institution/cityChart',
        name: 'CityChart',
        component: CityChart
      },
      {
        path: '/user/institution/chartDetail',
        name: 'ChartDetail',
        component: ChartDetail
      },
      {
        path: '/user/institution/chartDetail/participatingInstitutions',
        name: 'ParticipatingInstitutions',
        component: ParticipatingInstitutions
      },
      {
        path: '/user/institution/chartDetail/entryPages',
        name: 'EntryPages',
        component: EntryPages
      },
      {
        path: '/user/institution/cityChart/districtChart',
        name: 'DistrictChart',
        component: DistrictChart
      },
      {
        path: '/user/program/content',
        name: 'ProgramContent',
        component: ProgramContent
      }
    ]
  }

]//地址路径对应的组件


const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
